// === IMPORTS ===
import React from 'react';
import { LogOut, X, ShieldAlert, RotateCcw, User } from 'lucide-react';
import { ConnectedUserProfile } from './UserAccountMenu';
import '../styles/twin-modals-shared.css';
import './UserLogoutModal.css';

interface UserLogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmLogout: () => void;
  userProfile: ConnectedUserProfile;
  isLoggedOut: boolean;
  onReLogin: () => void;
}

// === COMPONENTE: MODAL DE CIERRE DE SESIÓN ===
export const UserLogoutModal: React.FC<UserLogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirmLogout,
  userProfile,
  isLoggedOut,
  onReLogin,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="twin-modal-overlay twin-logout-overlay"
      onClick={!isLoggedOut ? onClose : undefined}
    >
      <div
        className="twin-modal twin-logout-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {!isLoggedOut ? (
          <>
            {/* === HEADER === */}
            <div className="twin-logout-header">
              <div className="twin-logout-header-left">
                <div className="twin-logout-icon-circle">
                  <LogOut className="twin-icon-md" />
                </div>
                <div>
                  <h2 className="twin-logout-title">Sign Out</h2>
                  <p className="twin-logout-subtitle">End operator session</p>
                </div>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="twin-modal-close-btn twin-logout-close-btn"
                title="Cancel"
              >
                <X className="twin-icon-md" />
              </button>
            </div>

            {/* === CUERPO === */}
            <div className="twin-logout-body">
              <div className="twin-logout-profile-row">
                <div className="twin-logout-avatar">
                  {userProfile.name
                    .split(' ')
                    .map((p) => p[0])
                    .filter(Boolean)
                    .slice(0, 2)
                    .join('')
                    .toUpperCase() || <User className="twin-icon-md" />}
                </div>
                <div className="twin-logout-profile-info">
                  <div className="twin-logout-profile-name">{userProfile.name}</div>
                  <div className="twin-logout-profile-email">{userProfile.email}</div>
                  <div className="twin-logout-profile-role">{userProfile.role}</div>
                </div>
              </div>

              <div className="twin-logout-warning-box">
                <ShieldAlert className="twin-icon-sm twin-logout-warning-icon" />
                <div>
                  Are you sure you want to sign out of the system? All location changes and configurations have been securely saved locally.
                </div>
              </div>
            </div>

            {/* === FOOTER === */}
            <div className="twin-logout-footer">
              <button
                type="button"
                onClick={onClose}
                className="twin-btn twin-btn--secondary"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirmLogout}
                className="twin-btn twin-btn--danger twin-logout-confirm-btn"
              >
                <LogOut className="twin-icon-sm" />
                <span>Sign Out</span>
              </button>
            </div>
          </>
        ) : (
          /* === ESTADO: SESIÓN CERRADA === */
          <div className="twin-logout-ended-state">
            <div className="twin-logout-ended-icon-circle">
              <LogOut className="twin-icon-2xl" />
            </div>
            <div>
              <h3 className="twin-logout-ended-title">Session Ended</h3>
              <p className="twin-logout-ended-text">
                The session for <span className="twin-logout-ended-name">{userProfile.name}</span> has ended.
              </p>
            </div>

            <div className="twin-logout-ended-action">
              <button
                type="button"
                onClick={onReLogin}
                className="twin-btn twin-logout-resume-btn"
              >
                <RotateCcw className="twin-icon-md" />
                <span>Resume Session as {userProfile.name.split(' ')[0]}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};